module.exports = require('./generatePeAppComponent')
